class CustomSelect {
  constructor(originalSelect) {
    this.originalSelect = originalSelect;
    this.allOriginalSelects = document.querySelectorAll(
      `select[name=${this.originalSelect.name}]`
    );
    this.customSelect = document.createElement("div");
    this.customSelect.classList.add("select");

    this.originalSelect.querySelectorAll("option").forEach((optionElement) => {
      const itemElement = document.createElement("button");
      const itemElementImg = document.createElement("img");
      const itemElementInner = document.createElement("span");
      itemElementInner.textContent = optionElement.textContent;
      itemElementImg.setAttribute('src', optionElement.getAttribute('data-src'));

      itemElement.classList.add("select__item");
      itemElement.classList.add("btn-reset");
      // itemElement.textContent = optionElement.textContent;
      if ( optionElement.getAttribute('data-img') == 'true' ) {
        itemElement.appendChild(itemElementImg);
      }
      itemElement.appendChild(itemElementInner);
      this.customSelect.appendChild(itemElement);

      if (optionElement.selected === true) {
        this._select(itemElement);
      }

      itemElement.addEventListener("click", () => {
        if (
          this.originalSelect.multiple &&
          itemElement.classList.contains("select__item_selected")
        ) {
          this._deselect(itemElement);
        } else {
          this._select(itemElement);
        }
      });
    });

    this.originalSelect.insertAdjacentElement("afterend", this.customSelect);
    this.originalSelect.style.display = "none";
  }

  _select(itemElement) {
    const index = Array.from(this.customSelect.children).indexOf(itemElement);
  
    if (!this.originalSelect.multiple) {
      this.customSelect.querySelectorAll(".select__item").forEach((el) => {
        el.classList.remove("select__item_selected");
      });
    }
  
    const originalOptions = Array.from(
      this.originalSelect.querySelectorAll("option")
    );
    const itemElementValue = originalOptions[index].value;
  
    if (itemElementValue === "") {
      Array.from(this.allOriginalSelects).forEach((originalSelectInstance) => {
        // Сбрасываем все выбранные опции
        originalSelectInstance.querySelectorAll("option").forEach((item) => {
          item.selected = false;
        });
        // Выбираем только "all"
        originalOptions[index].selected = true;
  
        const customSelectInstance = originalSelectInstance.nextElementSibling;
  
        // Сбрасываем все выделенные элементы в кастомном селекте
        customSelectInstance
          .querySelectorAll(".select__item")
          .forEach((el) => {
            el.classList.remove("select__item_selected");
          });
        // Выделяем только "all"
        customSelectInstance.querySelectorAll(".select__item")[index].classList.add("select__item_selected");
      });
    } else {
      // Если выбран не "all", сначала сбросим "all" если он был выбран
      Array.from(this.allOriginalSelects).forEach((originalSelectInstance) => {
        const allOptionIndex = Array.from(originalSelectInstance.querySelectorAll("option")).findIndex(
          opt => opt.value === ""
        );
        if (allOptionIndex !== -1) {
          originalSelectInstance.querySelectorAll("option")[allOptionIndex].selected = false;
          originalSelectInstance.nextElementSibling
            .querySelectorAll(".select__item")
            [allOptionIndex].classList.remove("select__item_selected");
        }
  
        // Затем выбираем нужный элемент
        originalSelectInstance.querySelectorAll("option")[index].selected = true;
        originalSelectInstance.nextElementSibling
          .querySelectorAll(".select__item")
          [index].classList.add("select__item_selected");
      });
    }
  }

  _deselect(itemElement) {
    const index = Array.from(this.customSelect.children).indexOf(itemElement);
    const originalOptions = Array.from(
      this.originalSelect.querySelectorAll("option")
    );
    const itemElementValue = originalOptions[index].value;

    if (itemElementValue === "") {
      Array.from(this.allOriginalSelects).forEach((originalSelectInstance) => {
        originalSelectInstance.querySelectorAll("option").forEach((item, i) => {
          item.selected = false;
        });

        const customSelectInstance = originalSelectInstance.nextElementSibling;

        customSelectInstance
          .querySelectorAll(".select__item")
          .forEach((el, i) => {
            el.classList.remove("select__item_selected");
          });
      });
    } else {
      Array.from(this.allOriginalSelects).forEach((originalSelectInstance) => {
        originalSelectInstance.querySelectorAll("option").forEach((item, i) => {
          if (i === index) item.selected = false;
        });

        const customSelectInstance = originalSelectInstance.nextElementSibling;

        customSelectInstance
          .querySelectorAll(".select__item")
          .forEach((el, i) => {
            if (i === index) el.classList.remove("select__item_selected");
          });
      });
    }
  }
}

export default function customSelect() {
  document.querySelectorAll(".custom-select").forEach((selectElement) => {
    new CustomSelect(selectElement);
  });
}
